import useLazyVideo from '../../../hooks/useLazyVideo';

export default function VideoShowcase() {
  const videoRef = useLazyVideo('300px');

  return (
    <section className="bg-black w-full py-8">
      <div className="max-w-4xl mx-auto px-6">
        <video
          ref={videoRef}
          src="https://storage.readdy-site.link/project_files/d45d6433-09d1-4f4c-94b0-3f34b93f0615/273b65d7-ae17-4eec-b5bb-201a9deeef1b_TurnTable.mp4?v=93ff7fd41f4fe1c04f6410d1c14d6be9"
          loop
          muted
          playsInline
          preload="none"
          className="w-full h-auto block rounded-xl"
        />
      </div>
    </section>
  );
}
